import ReactGA from "react-ga4";
import { ICM_NAME_FULL } from "./constants";

export interface AnalyticsEvent {
    pageName: string;
    event: string;
}

export async function setAnalyticsEvent(pageName: string, event: string): Promise<void> {
    if (process.env.APP_GA_ENABLED === "true") {
        if (!process.env.APP_GA_KEY) {
            console.error("Google Analytics ID is missing in environment variables.");
            return;
        }
        try {
            // Initialize ReactGA with the Google Analytics ID
            ReactGA.initialize(process.env.APP_GA_KEY);
            // console.log(`Google Analytics initialized with ID: ${process.env.APP_GA_KEY}`);

            // Send a page view
            ReactGA.send({
                hitType: "pageview",
                page: pageName,
                title:  ICM_NAME_FULL + " GA",
            });
            // console.log(`Page view sent for page: ${pageName}`);

            // Send a custom event
            ReactGA.event({
                category: "User",
                label: event,
                action: event,
            });
            //  console.log(`Event sent for action: ${event}`);
        } catch (error) {
            console.error("Error sending analytics event:", error);
        }
    }
}
